import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { marketingLanguageOptions, MarketingLanguage } from "./marketingLocalePaths";

export default function MarketingLanguageMenu({
  value,
  label,
  onChange,
}: {
  value: MarketingLanguage;
  label: string;
  onChange: (language: MarketingLanguage) => void;
}) {
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
  const current = marketingLanguageOptions.find(option => option.code === value) ?? marketingLanguageOptions[0];
  return <>
    <button
      type="button"
      className="quant-language-trigger"
      aria-label={`${label}: ${current.label}`}
      aria-controls={anchor ? "quant-language-menu" : undefined}
      aria-expanded={Boolean(anchor)}
      aria-haspopup="menu"
      onClick={event => setAnchor(event.currentTarget)}
    >
      <span>{current.shortLabel}</span>
      <svg aria-hidden="true" viewBox="0 0 16 16" width="16" height="16"><path d="m3 6 5 5 5-5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </button>
    <Menu
      id="quant-language-menu"
      anchorEl={anchor}
      open={Boolean(anchor)}
      onClose={() => setAnchor(null)}
      MenuListProps={{ "aria-label": label }}
      PaperProps={{ className: "quant-language-popover", elevation: 0 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {marketingLanguageOptions.map(option => <MenuItem
        key={option.code}
        selected={value === option.code}
        onClick={() => { setAnchor(null); onChange(option.code); }}
        className="quant-language-item"
      >
        <span>{option.label}</span>
        {value === option.code ? <svg aria-hidden="true" width="15" height="15" viewBox="0 0 16 16"><path d="m3 8 3 3 7-7" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg> : null}
      </MenuItem>)}
    </Menu>
  </>;
}
